import type { ExtractPropTypes, PropType } from 'vue'
import type { IDatePickerType } from '@park-ui/components/date-picker/src/date-picker.type'

export type { IDatePickerType } from '@park-ui/components/date-picker/src/date-picker.type'

type sizeType = 'large' | 'default' | 'small'

export interface DataTypes {
  prop: string
  type: any | IDatePickerType
  label?: string
  defaultValue: string | Array<any> | number
  labelWidth?: string
  required?: boolean
  error?: string
  showMessage?: string
  inlineMessage?: string
  size?: sizeType
  options?: Array<any>
  attribute?: object
  [propName: string]: any
}

export const dateType = [
  'year',
  'month',
  'date',
  'dates',
  'datetime',
  'week',
  'datetimerange',
  'daterange',
  'monthrange',
] as Array<IDatePickerType>

type dataTypes = ExtractPropTypes<DataTypes>

export default {
  data: {
    type: Array as PropType<dataTypes[]>,
    require: true,
  },
  option: {
    type: Object,
    default: {
      max: 4,
      line: 4,
    },
  },
}
